import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent  {
  @Input() public code?: string;
  @Input() public message?: string;

  public currentDateTime: string;
  constructor(private datePipe: DatePipe){
      this.currentDateTime = this.datePipe.transform(Date.now(), 'dd/MM/yyyy 	HH:ss ZZZZ');
  }
}